import { Example } from "./Example";

import styles from "./Example.module.css";

export type ExampleModel = {
    text: string;
    value: string;
};

const EXAMPLES: ExampleModel[] = [
    {
        text: "What are the leave rules for management staff?",
        value: "What are the leave rules for management staff?"
    },
    { 
        text: "What are the miscellaneous expenses related to domestic travel?", 
        value: "What are the miscellaneous expenses related to domestic travel?"
    },
    { 
        text: "How many casual leaves are there in a year?", 
        value: "How many casual leaves are there in a year?" 
    }
];

interface Props {
    onExampleClicked: (value: string) => void;
}

export const ExampleList = ({ onExampleClicked }: Props) => {
    return (
        <ul className={styles.examplesNavList}>
            {EXAMPLES.map((x, i) => (
                <li key={i}>
                    <Example text={x.text} value={x.value} onClick={onExampleClicked} />
                </li>
            ))}
        </ul>
    );
};
